import { CommonModule } from '@angular/common';
import {Component, Input} from '@angular/core';
import { UiService } from 'src/app/services/ui.service';

@Component({
    selector: 'zoom-wrapper',
    template: `
<div *ngIf="(round(100/uiService.zoom_mulitplier) + '%') as percent" class="zoom-wrapper"[ngStyle]="{transform: 'scale('+uiService.zoom_mulitplier+')', height: percent, width: percent, maxHeight: percent, maxWidth: percent, left: left }">
  <ng-content></ng-content>
</div>
`,
    styleUrls: ['./zoom-wrapper.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class ZoomWrapper {
  @Input() left = '0px'
  round = Math.round
  constructor(public uiService: UiService) {}
}

